import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RateAuditSummaryReportComponent } from './rate-audit-summary-report.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { NglModule} from 'ng-lightning';
import { FormsModule } from '@angular/forms';
import{ ModalModule } from '../../common/component/modal/modal.module';
import{ modalComponent} from '../../common/component/modal/modal.component';


@NgModule({
    imports: [
        CommonModule,
        GridModule,
        NglModule,
        FormsModule,
        ModalModule
    ],
    declarations: [RateAuditSummaryReportComponent],
    exports: [RateAuditSummaryReportComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RateAuditSummaryReportModule { }
